export const refreshCheckPointChannelAction = 'refresh-check-point'

export const moveProductsAvailabilityAction = 'move-products-availability'

export const statisticsChannelAction = 'statistics'

export const changeStockChannelAction = 'change-stock'

export const ordersChannelAction = 'orders'
